/*
  Grid "Add to cart" with quantity stepper — Premier Pool & Spa custom.
  Markup: snippets/grid-add-to-cart.liquid. Event delegation, so it works for
  grid items injected later (ajax collection filtering, infinite scroll, search).
  On success it dispatches Impulse's own `ajaxProduct:added` event so the theme's
  cart drawer rebuilds itself and opens, exactly like the product page does.
*/
(function (w, d) {
  'use strict';
  var openWrap = null;

  function panel(wrap) { return wrap.querySelector('.grid-atc__panel'); }
  function numInput(wrap) { return wrap.querySelector('.grid-atc__num'); }

  function closePanel(wrap) {
    if (!wrap) return;
    var p = panel(wrap);
    if (p) p.hidden = true;
    wrap.classList.remove('is-open');
    var trigger = wrap.querySelector('[data-grid-atc-open]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (openWrap === wrap) openWrap = null;
  }

  function openPanel(wrap) {
    if (openWrap && openWrap !== wrap) closePanel(openWrap);
    var p = panel(wrap);
    if (!p) return;
    p.hidden = false;
    wrap.classList.add('is-open');
    var trigger = wrap.querySelector('[data-grid-atc-open]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    openWrap = wrap;
    var n = numInput(wrap);
    if (n) { n.focus(); n.select(); }
  }

  function clamp(wrap, value) {
    var v = parseInt(value, 10);
    if (!v || v < 1) v = 1;
    var max = parseInt(wrap.dataset.max, 10);
    if (max && v > max) v = max;
    return v;
  }

  function message(wrap, text, isError) {
    var m = wrap.querySelector('.grid-atc__msg');
    if (!m) return;
    m.textContent = text;
    m.classList.toggle('is-error', !!isError);
    if (text) {
      setTimeout(function () { if (m.textContent === text) m.textContent = ''; }, 3500);
    }
  }

  function addToCart(wrap) {
    var n = numInput(wrap);
    var qty = clamp(wrap, n ? n.value : 1);
    if (n) n.value = qty;
    var btn = wrap.querySelector('[data-grid-atc-add]');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }

    var url = (w.theme && w.theme.routes && w.theme.routes.cartAdd) || '/cart/add.js';

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(wrap.dataset.variantId), quantity: qty })
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok) {
          var err = (res.data && (res.data.description || res.data.message)) || 'Could not add to cart';
          message(wrap, err, true);
          return;
        }
        closePanel(wrap);
        if (n) n.value = 1;
        message(wrap, 'Added to cart', false);
        // Let Impulse's cart drawer rebuild and open (CartDrawer listens on document)
        d.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res.data }, bubbles: true }));
      })
      .catch(function () {
        message(wrap, 'Could not add to cart', true);
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
      });
  }

  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-grid-atc-open], [data-grid-atc-minus], [data-grid-atc-plus], [data-grid-atc-add]');
    if (!t) {
      // click outside any open stepper closes it
      if (openWrap && !e.target.closest('[data-grid-atc]')) closePanel(openWrap);
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    var wrap = t.closest('[data-grid-atc]');
    if (!wrap) return;
    var n = numInput(wrap);

    if (t.hasAttribute('data-grid-atc-open')) {
      wrap.classList.contains('is-open') ? closePanel(wrap) : openPanel(wrap);
    } else if (t.hasAttribute('data-grid-atc-minus')) {
      if (n) n.value = clamp(wrap, parseInt(n.value, 10) - 1);
    } else if (t.hasAttribute('data-grid-atc-plus')) {
      if (n) n.value = clamp(wrap, parseInt(n.value, 10) + 1);
    } else if (t.hasAttribute('data-grid-atc-add')) {
      addToCart(wrap);
    }
  });

  d.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.classList && e.target.classList.contains('grid-atc__num')) {
      e.preventDefault();
      addToCart(e.target.closest('[data-grid-atc]'));
    } else if (e.key === 'Escape' && openWrap) {
      closePanel(openWrap);
    }
  });

  d.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('grid-atc__num')) {
      var wrap = e.target.closest('[data-grid-atc]');
      if (wrap) e.target.value = clamp(wrap, e.target.value);
    }
  });
})(window, document);
